module.exports = __webpack_public_path__ + "static/img/no_sign.eaf0aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_sign.png
// module id = 4kJr
// module chunks = 167